import React, { useState, useEffect, memo } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiClock, FiGitPullRequest } from 'react-icons/fi';

const SLABadge = ({ breachAt, status, metadata }) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    if (!breachAt || status === 'resolved' || status === 'closed') return;

    const interval = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(interval);
  }, [breachAt, status]);

  if (!breachAt) return null;
  if (status === 'resolved' || status === 'closed') return null;

  if (status === 'Review-Patch-Pending') {
    return (
      <div aria-live="polite" role="status" className="px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-widest flex items-center gap-1.5 bg-cyan-500/20 text-cyan-400 ring-1 ring-inset ring-cyan-500/50 ring-opacity-20 shadow-[0_0_10px_rgba(6,182,212,0.2)] animate-pulse">
        <SafeIcon icon={FiGitPullRequest || FiClock} className="text-xs" />
        PATCH REVIEW PENDING
      </div>
    );
  }

  const diffMs = new Date(breachAt) - now;

  let label = '';
  let className = '';

  if (diffMs <= 0) {
    label = 'BREACHED';
    className = 'bg-rose-500/20 text-rose-500 ring-1 ring-inset ring-rose-500 ring-opacity-20 shadow-[0_0_10px_rgba(244,63,94,0.3)]';
  } else if (metadata?.sla_warning === true && diffMs <= 3600000) {
    label = '⚠️ SLA Warning (<60m)';
    className = 'bg-amber-500/20 text-[#FDD023] ring-1 ring-inset ring-amber-500/50 ring-opacity-50 shadow-[0_0_15px_rgba(245,158,11,0.4)] animate-pulse';
  } else if (metadata?.sla_warning === true) {
    label = '⚠️ SLA WARNING';
    className = 'bg-amber-500/20 text-[#FDD023] ring-1 ring-inset ring-amber-500/50 ring-opacity-50 shadow-[0_0_15px_rgba(245,158,11,0.4)] animate-pulse';
  } else if (diffMs < 7200000) { // Under 2 hours
    const h = Math.floor(diffMs / 3600000);
    const m = Math.floor((diffMs % 3600000) / 60000);
    label = `${h}h ${m}m left`;
    className = 'animate-pulse text-rose-400 bg-rose-500/10 ring-1 ring-inset ring-rose-500/30 ring-opacity-20';
  } else {
    const h = Math.floor(diffMs / 3600000);
    const m = Math.floor((diffMs % 3600000) / 60000);
    label = `${h}h ${m}m left`;
    className = 'text-zinc-400 bg-zinc-800/50 ring-1 ring-inset ring-zinc-700 ring-opacity-20';
  }

  return (
    <div aria-live="polite" role="status" className={`px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-widest flex items-center gap-1.5 ${className}`}>
      <SafeIcon icon={FiClock} className="text-xs" />
      {label}
    </div>
  );
};

export default memo(SLABadge);
